import useReveal from "@/hooks/useReveal";
import ConsultationForm from "./ConsultationForm";

export default function FinalCTA({ source, formCtaLabel } = {}) {
  useReveal();
  return (
    <section
      id="consultation"
      data-testid="final-cta-section"
      className="relative bg-paper py-24 md:py-36 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-teal-light/60 blur-3xl pointer-events-none"
      />

      <div className="relative max-w-[1320px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-6 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-teal" />
              <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-gray-600">
                Your Next Step
              </p>
            </div>
            <h2 className="font-display text-[38px] md:text-[52px] lg:text-[58px] leading-[1.05] tracking-tight text-ink">
              Before making this major decision alone,{" "}
              <span className="italic">
                consult with an attorney who understands what you are going
                through.
              </span>
            </h2>
            <p className="mt-8 text-[18px] leading-[1.75] text-gray-800 max-w-[52ch]">
              No obligation to retain us. Just a confidential conversation
              about your situation and your options.
            </p>
            <ul className="mt-10 space-y-5">
              {[
                "We'll listen.",
                "We'll answer your questions.",
                "We'll tell you what comes next.",
              ].map((line, i) => (
                <li
                  key={line}
                  data-testid={`final-cta-promise-${i}`}
                  className="flex items-center gap-5"
                >
                  <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-teal w-8">
                    0{i + 1}
                  </span>
                  <span className="font-display italic text-[26px] md:text-[30px] leading-tight text-ink">
                    {line}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-12 hidden lg:block">
              <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-gray-600 mb-3">
                Or schedule by phone
              </p>
              <a
                href="tel:+17147337066"
                data-testid="final-cta-phone"
                className="inline-flex items-center gap-4 bg-teal text-ink hover:bg-ink hover:text-paper transition-colors duration-300 px-7 py-4 font-display text-3xl md:text-[34px] leading-none"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                (714) 733&ndash;7066
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 reveal">
            <ConsultationForm
              variant="final"
              source={source}
              ctaLabel={formCtaLabel}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
